import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ArrowDown3, Logout, Profile, ProfileCircle } from "iconsax-react";
import { Menu, MenuButton, MenuList } from "@chakra-ui/react";
import { useQuery } from "@tanstack/react-query";
import { clearUserData, LSSB } from "../utils/LSSB_live";

const Topbar = ({ setIsSidebar }) => {
  const [logo, setLogo] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  let userData = sessionStorage.getItem("lssbAdminData");
  userData = JSON.parse(userData);
  const fetchProfile = async (page) => {
    let res = await LSSB.make_API_call({
      $k: userData.token,
      _endpoint: "fetch_users",
      $where: { _id: "$self" },
    });
    //console.log("grants rsss=====>>>", res);

    return res;
  };
  const profileQuery = useQuery(["profile"], () => fetchProfile());

  //console.log("user Profile===>>> ", profileQuery.data);

  let profileData = profileQuery.data?.data?.data || [];

  //   useQuery(
  //     ["getMerchantProfile"],
  //     () => getMerchantProfile(),
  //     {
  //       keepPreviousData: true,
  //       refetchOnWindowFocus: "always",
  //     }
  //   );

  //   async function getMerchantProfile() {
  //     try {
  //       const response = await api.getMerchantProfile();
  //       //console.log("merchant profile", response);
  //       setLogo(response.data?.logoUrl);
  //       // //console.log(document.getElementById("profile"));
  //       //console.log("logo", response.data?.logoUrl);
  //       return response;
  //     } catch (error) {
  //       return error;
  //     }
  //   }

  return (
    <div className="flex w-full items-center justify-between px-6 gap-[16px] py-3 border-b border-[#7C8493]">
      <div className="flex items-center">
        <button
          className="h-8 w-8 bg-[#AF8544] px-2 py-2 rounded-lg lg:hidden mr-2 flex justify-center items-center"
          onClick={setIsSidebar}
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M4 6H20"
              stroke="#fff"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M4 12H20"
              stroke="#fff"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M4 18H20"
              stroke="#fff"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
        <h4 className="text-[20px] text-[#1a202c] font-bold hidden md:block">
          {location.pathname === "/dashboard"
            ? "Dashboard"
            : location.pathname === "/notification"
            ? "Notification"
            : location.pathname === "/grants"
            ? "Award/Grants"
            : location.pathname === "/myapplication"
            ? "Applications"
            : location.pathname === "/myprofile"
            ? "Profile"
            : location.pathname === "/settings"
            ? "Settings"
            : location.pathname === "/invoice"
            ? "Invoice"
            : location.pathname === "/register"
            ? "Award Registration"
            : location.pathname === "/application/application-details"
            ? "Application Details"
            : ""}
        </h4>{" "}
      </div>
      <div className="flex items-center  gap-3">
        <Menu>
          <MenuButton bg={"none"}>
            <div className="flex items-center  gap-3  rounded-lg borde  py-1 px-2">
              <div className="flex items-center gap-2">
                {profileData?._fields?.image ? (
                  <img
                    src={profileData?._fields?.image}
                    alt="profile"
                    className="h-[30px] w-[30px] md:h-[35px] md:w-[35px] rounded-full "
                  />
                ) : (
                  <ProfileCircle size="35" color="#7e828b" variant="Bulk" />
                )}
                <p className="text-black font-semibold">
                  {" "}
                  {profileData?._fields?.fullname}
                </p>
              </div>

              <button>
                <ArrowDown3 variant="Bold" size="14" color="#000" />
              </button>
            </div>
          </MenuButton>
          <MenuList
            maxW="240px"
            w="240px"
            className="border-[2px] p-[10px] md:p-[16px]"
          >
            <div className="mt-3">
              <Link
                // onClick={() => setIsSettingsModal(true)}
                to="/myprofile"
                className="py-[6px] px-[12px] border-[0.2px] flex items-center bg-[#AF8544]  rounded-md border-[#98A2B3] w-full flex-item gap-2"
              >
                <Profile size={16} color="#fff" />{" "}
                <p className="text-[#fff] text-[12px]  xl:text-[12px] font-normal leading-[18px] ">
                  Profile
                </p>
              </Link>
            </div>

            <div className="py-[16px] border-t-[0.2px]  border-[#98A2B3] mt-[10px] ">
              <button
                onClick={() => {
                  clearUserData();
                  navigate("/login");
                }}
                className="flex gap-2 mt-[20px]"
              >
                {" "}
                <Logout size={20} color="#D78E20FF " />{" "}
                <p className="text-[#D78E20FF ] text-[12px]  xl:text-[14px] font-normal leading-[18px] ">
                  Log out
                </p>
              </button>
            </div>
          </MenuList>
        </Menu>
      </div>
    </div>
  );
};

export default Topbar;
